export const experienceData = [
    {
        title: "Math Content Teacher",
        institution: "ThinkAcademy | Bellevue, US",
        duration: "Oct 2025 - current",
        icon: "📚",
        category: "other",
        responsibilities: [
            "Manage classroom dynamics while teaching K-12 mathematics, adapting instructional strategies to break down logic problems for different skill levels.",
            "Evaluate student performance through regular assessments, providing structured feedback to parents to track progress and refine learning goals.",
            "Develop and implement engaging lesson plans that cater to diverse learning styles and abilities."
        ]
    },
    {
        title: "Software Engineer Intern",
        institution: "SyncSo | Remote, US",
        duration: "Sep 2024 - June 2025",
        icon: "💻",
        category: "professional",
        responsibilities: [
            "Engineer full-stack features using Java Spring Boot, React Native (TypeScript), and Redux Toolkit, integrating OpenAI LLM capabilities for automated content generation and optimizing prompts for reliable performance.",
            "Implement asynchronous view capture using ViewShot, boosting post shares and user signups.",
            "Develop reusable media carousel component with custom heuristics for lazy loading and conditional rendering to decouple data binding from UI and maintain smooth performance.",
            "Collaborate with design teams to accelerate delivery in an iterative environment, ensuring production stability through Postman API validation and Docker deployments."
        ]
    },
    {
        title: "React Native Developer Intern",
        institution: "Cliques | Remote, US",
        duration: "June 2024 - Sep 2024",
        icon: "📱",
        category: "professional",
        responsibilities: [
            "Implement scalable React Native components using TypeScript for a cross-platform dark mode system, ensuring visual consistency and type safety across iOS and Android.",
            "Refine and optimize user interfaces using Material-UI and Styled-components, significantly improving application responsiveness and aligning with accessibility standards.",
            "Diagnose and resolve critical defects within a CI/CD and Jira-managed workflow, maintaining production stability and supporting reliable feature deployments."
        ]
    },
    {
        title: "President",
        institution: "Technology and Business Association, UW | Seattle, WA",
        duration: "Dec 2023 – Dec 2024",
        icon: "🚀",
        category: "community",
        responsibilities: [
            "Lead strategic planning and execution of events (workshops, hackathons, networking nights), attracting 200+ attendees and bridging business and tech communities.",
            "Manage cross-functional teams of 20+ volunteers, secure sponsors, and collaborate with engineers, alumni, and PMs to host product-focused workshops and career panels.",
            "Redesign and launch the club's website using Figma and Webflow, applying PM principles like user journey mapping and design iteration to improve UX and event engagement.",
            "Grow membership through inclusive events, targeted outreach, and consistent digital branding."
        ]
    },
    {
        title: "Undergraduate Research Assistant",
        institution: "The Makeability Lab, Paul G. Allen School of CSE | Seattle, WA",
        duration: "Dec 2023 – Dec 2024",
        icon: "🎓",
        category: "research",
        publicationLink: "https://pmc.ncbi.nlm.nih.gov/articles/PMC12279023/",
        responsibilities: [
            "Publication: Jaewook Lee, ... Jiawen Zhang, et al. (2024). CookAR: Affordance Augmentations in Wearable AR. In UIST '24. [Belonging & Inclusion Best Paper]",
            "Collaborate with a Ph.D. mentor on research at the intersection of Augmented Reality (AR), Machine Learning, and accessibility.",
            "Collect and annotate image datasets to help train machine learning models for context-aware AR cooking applications.",
            "Support the development of assistive tools for the Blind and Low Vision (BLV) community."
        ]
    },
    {
        title: "Diversity Committee Member",
        institution: "Woman in Informatics | Seattle, WA",
        duration: "Oct 2023 – Oct 2024",
        icon: "🤝",
        category: "community",
        responsibilities: [
            "Host accessibility related research panel talk, bringing together researchers and practitioners to discuss inclusive technology.",
            "Serve as technical mentor for \"social for good\" ischool hackathon for high school students, guiding teams through technical challenges and project development.",
            "Assist winfo events and support diversity initiatives to create inclusive spaces in technology and informatics."
        ]
    },
    {
        title: "Undergraduate Teacher Assistant",
        institution: "University of Washington | Seattle, WA",
        duration: "Sep 2022 – Dec 2024",
        icon: "👩‍🏫",
        category: "professional",
        responsibilities: [
            "Support student learning in Python, Data Science and Web development through labs, office hours, and assignment support.",
            "Guide 25+ students weekly in course concepts, improving their coding confidence and problem-solving skills."
        ]
    }
];
